import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import SearchIcon from '@material-ui/icons/Search'
import Button from '@material-ui/core/Button'

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    minHeight: '100%',
    flex: 1,
    padding: 8,
  },
  placeholderTitle: {
    color: '#00660f',
    fontSize: 20,
    fontWeight: 400,
  },
  placeholderText: {
    fontSize: 16,
    maxWidth: 250,
    color: '#949494',
    fontWeight: 'bold',
  },
  placeholderImage: {
    maxWidth: '100%',
    marginBottom: 36,
    width: 140,
  },
})

const SearchResultPlaceholder = ({ classes, resetFilter, filter }) => {
  return (
    <div className={classes.root}>
      <SearchIcon style={{ fontSize: 80, color: '#00A550' }} />
      <Typography variant={'title'} gutterBottom className={classes.placeholderTitle}>
        Nenhum resultado foi encontrado para os critérios de filtro selecionados.
      </Typography>
      <Button
        onClick={() => resetFilter(filter.getPlainAllFiltersChecked())}
        style={{
          flex: '0 0 auto',
          margin: '12px',
          minWidth: '5rem',
          color: '#fff',
          backgroundColor: '#5FB9FF',
        }}
        variant="contained"
      >
        <span>LIMPAR FILTRO E REFAZER BUSCA</span>
      </Button>
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(SearchResultPlaceholder)
